import { useTranslation } from "react-i18next";
import { Outlet, useOutletContext, useSearchParams } from "react-router";
import { SubNav } from "../components/SubNav";
import LearningHub from "./learning/LearningHub";
import Matrix from "./learning/Matrix";
import Needs from "./learning/Needs";
import Outcomes from "./learning/Outcomes";
import Programmes from "./learning/Programmes";
import Succession from "./learning/Succession";
import { usePeopleCompany } from "./People";

/** Learning and development (WP-23.1, OS-0615): the roadmap, the standard programmes, the capability gap, the
 * competency matrix and succession.
 *
 * This was one page of twelve sections that fired eight requests on first paint. The overview and the matrix now
 * read only the People overview the module shell has already fetched, so they cost nothing extra to open; the
 * three screens that need their own data fetch only their own. */

export const LEARNING_SCREENS = ["programmes", "needs", "outcomes", "matrix", "succession"] as const;

export default function Learning() {
  const { t } = useTranslation();
  const company = usePeopleCompany();
  const [params] = useSearchParams();
  const query = params.get("company") ? `?company=${encodeURIComponent(params.get("company")!)}` : "";

  const items = [
    { key: "overview", to: `/people/learning${query}`, label: t("ld.tabs.overview"), end: true },
    ...LEARNING_SCREENS.map((k) => ({ key: k, to: `/people/learning/${k}${query}`, label: t(`ld.tabs.${k}`) })),
  ];

  return (
    <div data-learning>
      <SubNav items={items} label={t("ld.sections")} />
      <Outlet context={{ company }} />
    </div>
  );
}

const useCompany = () => useOutletContext<{ company: string }>().company || undefined;

export const LearningIndex = () => <LearningHub company={useCompany()} />;
export const LearningProgrammes = () => <Programmes company={useCompany()} />;
export const LearningNeeds = () => <Needs company={useCompany()} />;
export const LearningOutcomes = () => <Outcomes company={useCompany()} />;
export const LearningMatrix = () => <Matrix company={useCompany()} />;
export const LearningSuccession = () => <Succession company={useCompany()} />;
